import { render, staticRenderFns } from "./ApprovalCommonData.vue?vue&type=template&id=5f66b11e"
import script from "./ApprovalCommonData.vue?vue&type=script&lang=js"
export * from "./ApprovalCommonData.vue?vue&type=script&lang=js"
import style0 from "./ApprovalCommonData.vue?vue&type=style&index=0&id=5f66b11e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports